import Store from 'store/store';

Store.on('DISPLAY_EXTERNAL_LINK_MODAL', ({ href, onClick, originalEvent, target }) => {
	Store.get().externalLinkModal.set({
		open: true,
		href,
		target,
		originalEvent,
		onClick
	});
});

Store.on('HIDE_EXTERNAL_LINK_MODAL', () => {
	Store.get().externalLinkModal.set({ open: false });
});
